import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  inpatientList: [],
  inpatientReview: [],
  ipWorksheet: { dxs: [], pxs: [] },
  responseRow: {},
  responseDRG: null,
  responsePatStat: null,
  responsePOO: null,
  proReview: [],
  proWorksheet: {},
  outpatientList: [],
  outpatientReview: [],
  opWorksheet: {},
  ipListStatistics: [],
  ipListMeta: { reasonForChangeList: [], responseRequiredList: [] },
  opListStatistics: [],
  opListMeta: { reasonForChangeList: [], responseRequiredList: [] },
  proListStatistics: [],
  proListMeta: { reasonForChangeList: [], responseRequiredList: [] },
  ambListStatistics: [],
  ambListMeta: { reasonForChangeList: [], responseRequiredList: [] },
  showAddProjectForm: false,
  newProjectID: 0,
  projectList: [],
  projectLoading: false,
  projectPK: 0,
  project: {}
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
